export const richtwertEinheitAuswahl = {
  euro: 'euro',
  stunden: 'stunden',
  exakt: 'exakt',
} as const;

export type RichtwertEinheitAuswahl = keyof typeof richtwertEinheitAuswahl;
